import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import WorkItemsStore from "./WorkItemsStore";

const workItemsRoute: RouteType[] = [
  {
    name: "Work Items",
    path: "/devops/work-items",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Work Items",
        enableRefreshButton: true,
        component: () => import("./WorkItems.Header"),
      },
      body: {
        component: () => import("./WorkItems.Body"),
        grayBackground: true,
      },
    },
    group: "DevOps",
    searchAliases: ["tickets", "tasks", "ado", "azure devops"],
    // Reads (running a WIQL query) require authentication only (viewer+); the
    // API enforces the read gate. Updates to a work item are admin/operator —
    // gated in the store (`canManage`) and enforced by the API RBAC seam.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.workItemsStore as WorkItemsStore;
      store?.initialize();
      // Seed the global client list so a connection bound to a client can be
      // named (and linked to Client 360) instead of showing a raw id.
      const clientStore = (rootStore as Record<string, unknown>).clientStore as
        | { fetchClients?: () => Promise<void>; clients?: unknown[] }
        | undefined;
      if (clientStore && !(clientStore.clients && clientStore.clients.length)) {
        clientStore.fetchClients?.();
      }
    },
    onExit: ({ rootStore }) => {
      const store = rootStore.workItemsStore as WorkItemsStore;
      store?.dispose();
    },
    dialogs: [
      {
        name: "DevOpsWorkItemFormDialog",
        title: "Update Work Item",
        submitButtonText: "Update work item",
        component: () => import("./dialogs/WorkItemForm.Body"),
        cancelButton: true,
        height: 480,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.workItemsStore as WorkItemsStore;
          const ok = await store.saveWorkItem();
          // Throwing keeps the dialog open so the error stays visible in
          // the form's alert; resolving closes it and the error is lost.
          if (!ok) {
            throw new Error(store.formError || "Failed to update work item");
          }
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.workItemsStore as WorkItemsStore;
          return store.isFormValid;
        },
      },
    ],
  },
];

export default workItemsRoute;
